import { writable } from 'svelte/store';
import { UsageService } from '../../services';
import '@/types/user';
const usageService = new UsageService();
const initialUsageState = {
    loaded: false,
    owner: '',
    id: 0,
    amount: 0
};
const { subscribe, update } = writable(initialUsageState);
let usageState;
subscribe(usage => (usageState = usage));
const actions = {
    getCredits: async () => {
        const credit = await usageService.getCredit();
        update(store => {
            credit.loaded = true;
            return credit;
        });
    },
    setC: async (credit) => {
        update(store => {
            return {
                ...store,
                owner: credit.owner,
                id: credit.id,
                amount: credit.amount,
                loaded: true
            };
        });
    },
    setCredits: async (credit) => {
        update(usage => {
            return {
                ...usage,
                owner: credit.owner,
                id: credit.id,
                amount: credit.amount,
                loaded: true
            };
        });
    }
};
const credit = {
    ...actions,
    subscribe
};
export default credit;
